var _path, _path2, _path3, _path4, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRobot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24551 17.3563C8.89078 17.3563 9.41388 16.8332 9.41388 16.1879C9.41388 15.5426 8.89078 15.0195 8.24551 15.0195C7.60024 15.0195 7.07715 15.5426 7.07715 16.1879C7.07715 16.8332 7.60024 17.3563 8.24551 17.3563Z",
    fill: "#FF5252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6689 17.3563C14.3141 17.3563 14.8372 16.8332 14.8372 16.1879C14.8372 15.5426 14.3141 15.0195 13.6689 15.0195C13.0236 15.0195 12.5005 15.5426 12.5005 16.1879C12.5005 16.8332 13.0236 17.3563 13.6689 17.3563Z",
    fill: "#FF5252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.588 13.0053H19.1865V10.2694C19.1865 9.56944 18.6174 9.0003 17.9177 9.0003L3.93947 9C3.23947 9 2.67003 9.56944 2.67003 10.2691V13.005H1.26944C0.569742 13.005 0 13.5748 0 14.2751V18.3526C0 19.0523 0.569742 19.6227 1.26944 19.6227H2.67003V22.3589C2.67003 23.0586 3.23977 23.628 3.93947 23.628H17.9177C18.6174 23.628 19.1865 23.0586 19.1865 22.3589V19.6227H20.588C21.2877 19.6227 21.8572 19.0523 21.8572 18.3526V14.2754C21.8572 13.5751 21.2877 13.0053 20.588 13.0053ZM2.67003 18.1968H1.42556V14.4312H2.67003V18.1968ZM17.7613 13.0056V13.7186V14.4312V18.1971V18.9094V19.6227V22.2018H4.09589V19.6227V18.9094V18.1968V14.4312V13.7186V13.0056V10.4262H17.7613V13.0056ZM20.4316 18.1965H19.1865V14.4312H20.4316V18.1965Z",
    fill: "#FF5252"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 10V4.5",
    stroke: "#FF5252",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 3,
    r: 2,
    stroke: "#FF5252",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.7dae132d.svg";
export { ForwardRef as ReactComponent };